import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { NAV_MAIN, NAV_EXTRA, CONTACT_EMAIL } from "../../i18n/fr";

export const Footer = () => (
  <footer className="bg-[#4A0C1B] text-[#EDE3D9]" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-[1.4fr_1fr_1fr] lg:px-12">
      <div className="space-y-4">
        <Logo light testid="footer-logo" />
        <p className="eyebrow !text-[#EDE3D9]/80">La finance simplifiée</p>
        <p className="font-display text-lg text-[#FFFDFB]">Structurer • Protéger • Propulser</p>
        <a href={`mailto:${CONTACT_EMAIL}`} className="text-sm underline-offset-4 hover:underline" data-testid="footer-email">{CONTACT_EMAIL}</a>
      </div>
      <ul className="space-y-2.5 text-sm">
        {NAV_MAIN.map((n) => <li key={n.to}><Link to={n.to} className="hover:text-[#FFFDFB]" data-testid={`footer-${n.testid}`}>{n.label}</Link></li>)}
      </ul>
      <ul className="space-y-2.5 text-sm">
        {NAV_EXTRA.map((n) => <li key={n.to}><Link to={n.to} className="hover:text-[#FFFDFB]" data-testid={`footer-${n.testid}`}>{n.label}</Link></li>)}
        <li><Link to="/politique-de-confidentialite" className="hover:text-[#FFFDFB]" data-testid="footer-privacy">Politique de confidentialité</Link></li>
      </ul>
    </div>
    <div className="border-t border-[#FFFDFB]/10">
      <div className="mx-auto max-w-7xl space-y-2 px-5 py-6 text-xs text-[#EDE3D9]/70 sm:px-8 lg:px-12">
        <p data-testid="footer-regulatory">STRUKTIV n'est pas une institution financière. Les contenus du site sont informatifs.</p>
        <p>© {new Date().getFullYear()} STRUKTIV. Tous droits réservés.</p>
      </div>
    </div>
  </footer>
);
